module.exports = __webpack_public_path__ + "media/images/ic_chevron_left_black_24px-ae7b441873e747db908ced8c3a09a035.svg";